module.exports = __webpack_public_path__ + "static/media/a_04.9878631e.jpg";